import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { X, Check, Calendar, Wrench, LineChart, Calculator, RefreshCw, Map } from 'lucide-react';
export function MaquinaAdministrativa() {
  const comparisons = [{
    task: 'Saber qué hacer hoy',
    without: 'Intuición',
    with: 'Calendario diario'
  }, {
    task: 'Mecánica organizada',
    without: 'Cuando puedo',
    with: 'Día de service programado'
  }, {
    task: 'Medir el progreso',
    without: 'Sensación vaga',
    with: 'Tracker trimestral'
  }, {
    task: 'Saber cuánto ahorré',
    without: 'No se registra',
    with: 'Calculadora de ROI'
  }, {
    task: 'Volver tras pausa',
    without: 'No sé por dónde empezar',
    with: 'Protocolo de regreso'
  }, {
    task: 'Preparar un evento',
    without: 'Improvisación',
    with: 'Hoja de ruta completa'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-5xl mx-auto" data-id="element-224">
      <FadeIn data-id="element-225">
        <div className="text-center mb-6 md:mb-12" data-id="element-226">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 rounded-full bg-[#22c55e]/10 mb-3 md:mb-6 border border-[#22c55e]/20 relative" data-id="element-227">
            <div className="absolute inset-0 bg-[#22c55e]/20 blur-xl rounded-full animate-pulse" data-id="element-228"></div>
            <Calendar className="text-[#16a34a] relative z-10 w-7 h-7 md:w-10 md:h-10" data-id="element-229" />
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] mb-2 md:mb-4 px-2" data-id="element-230">
            ¿QUÉ AGREGA EL MASTER-PLAN 365?
          </h2>
          <p className="text-sm md:text-xl text-[#475569] font-bold max-w-2xl mx-auto" data-id="element-231">
            El sistema que convierte 600 páginas en resultados reales.
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-6 md:mb-12" data-id="element-232">
        <FadeIn delay={0.2} data-id="element-233">
          <div className="bg-[#ef4444]/5 border border-[#ef4444]/20 rounded-2xl p-4 md:p-8 h-full" data-id="element-234">
            <div className="flex items-center gap-3 mb-4 md:mb-8 pb-3 md:pb-4 border-b border-[#ef4444]/10" data-id="element-235">
              <div className="bg-[#ef4444]/10 p-1.5 md:p-2 rounded-lg" data-id="element-236">
                <X className="text-[#ef4444] w-5 h-5 md:w-6 md:h-6" data-id="element-237" />
              </div>
              <h3 className="text-base md:text-xl font-black text-[#ef4444]" data-id="element-238">
                Sin Master-Plan
              </h3>
            </div>
            <div className="space-y-3 md:space-y-6" data-id="element-239">
              {comparisons.map((item, i) => <div key={i} className="flex flex-col gap-0.5 md:gap-1" data-id="element-240">
                  <span className="text-xs md:text-sm text-[#475569] font-bold" data-id="element-241">
                    {item.task}
                  </span>
                  <span className="text-base md:text-lg font-mono text-[#0f172a] font-medium" data-id="element-242">
                    {item.without}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-243">
          <div className="bg-white border-2 border-[#22c55e]/50 rounded-2xl p-4 md:p-8 h-full relative overflow-hidden shadow-[0_10px_30px_rgba(34,197,94,0.1)]" data-id="element-244">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#22c55e]/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-245"></div>

            <div className="flex items-center gap-3 mb-4 md:mb-8 pb-3 md:pb-4 border-b border-[#22c55e]/20 relative z-10" data-id="element-246">
              <div className="bg-[#22c55e] p-1.5 md:p-2 rounded-lg shadow-[0_0_15px_rgba(34,197,94,0.5)]" data-id="element-247">
                <Check className="text-[#020617] w-5 h-5 md:w-6 md:h-6" strokeWidth={3} data-id="element-248" />
              </div>
              <h3 className="text-base md:text-xl font-black text-[#16a34a]" data-id="element-249">
                Con Master-Plan 365
              </h3>
            </div>
            <div className="space-y-3 md:space-y-6 relative z-10" data-id="element-250">
              {comparisons.map((item, i) => <div key={i} className="flex flex-col gap-0.5 md:gap-1" data-id="element-251">
                  <span className="text-xs md:text-sm text-[#475569] font-bold" data-id="element-252">
                    {item.task}
                  </span>
                  <span className="text-sm md:text-lg font-mono font-black text-[#020617] bg-[#22c55e]/20 w-fit px-2 md:px-3 py-0.5 md:py-1 rounded-md border border-[#22c55e]/30" data-id="element-253">
                    {item.with}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>

      <FadeIn delay={0.4} data-id="element-254">
        <div className="flex flex-wrap justify-center gap-2 md:gap-6" data-id="element-255">
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e2e8f0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#0f172a] shadow-sm" data-id="element-256">
            <Calendar size={14} className="text-[#22c55e]" data-id="element-257" /> Calendario
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e2e8f0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#0f172a] shadow-sm" data-id="element-258">
            <Wrench size={14} className="text-[#22c55e]" data-id="element-259" /> Mecánica
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e2e8f0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#0f172a] shadow-sm" data-id="element-260">
            <LineChart size={14} className="text-[#22c55e]" data-id="element-261" /> Progreso
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e2e8f0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#0f172a] shadow-sm" data-id="element-262">
            <Calculator size={14} className="text-[#22c55e]" data-id="element-263" /> ROI
          </div>
        </div>
        <p className="text-center text-sm md:text-base text-[#16a34a] font-black mt-3 md:mt-6" data-id="element-264">
          Implementación guiada semana a semana · 365 días · Resultados medibles
        </p>
      </FadeIn>
    </section>;
}